 export const CiBandDisplayToResponseKey: Record<string, string> = {
    'FACE_NOT_VISIBLE': 'FND',
    'CANDIDATE_NOT_PRESENT': 'CNP',
    'CANDIDATE_LOOKING_AWAY_FROM_SCREEN': 'CLA',
    'CANDIDATE_FACE_PARTIALLY_VISIBLE': 'FPV',
    'AWAY_FROM_WINDOW': 'UNAP',
    'ANOTHER_PERSON': 'MFD',
    'CANDIDATE_IMPERSONATION_SUSPECTED': 'CID',
    'TOTAL_SPEECH_DURATION': 'TSD',
    'CUMULATIVE_COUNT_RED(FNV, CNP, APT, MPD, CIS, ATW)': 'CCR',
    'Cumulative_Count_Yellow(CLAS, CFPV)': 'CCY',
    'Cumulative_Count_Red_Yellow(FNV, CNP, APT, MPD, CIS, ATW, CLAS, CFPV)': 'CCRY',
    'MOBILE_PHONE_DETECTED': 'MPD'
};


export const PageViewType = {
    HOME_PAGE: "HOME_PAGE",
    TABLE_PAGE: "TABLE_PAGE",
    EDIT_BAND_SCORE_PAGE: "EDIT_BAND_SCORE_PAGE",
    OVERALL_BAND_PAGE: "OVERALL_BAND_PAGE"
}

 export const CiStatus = {
        ENABLE: 'ENABLE',
        DISABLE: 'DISABLE',
        ENABLE_DEFAULT: 'ENABLE_DEFAULT'
    }



